<template>
  <div class="selectCar">
    <div :class="{'isiOSX':isiOSX}" class="top" id="top">
      <img src="./../../assets/selfSupport/backlast@2x.png" alt @click="goBack" />
      <span @click="journeyInformation()">5月12日 11:15 前往杭州萧山国际机场T2航站楼</span>
    </div>
    <div class="content" :class="{'isIosContent':isiOSX}">
      <div class="left" :class="{'isIosLeft':isiOSX}">
        <div
          v-for="(item,index) in carTypeList"
          :key="index"
          @click="carTab(item,index)"
          class="tab"
          :class="{'checktab':item.checked}"
        >
          <p>{{item.carType}}</p>
          <span class="tiptitle">{{item.litleTip}}</span>
          <span class="rightIcon" v-show="item.iconCheck">{{item.num}}</span>
        </div>
      </div>
      <div class="right">
        <div class="carlist" v-for="(item,index) in carTypeList" :key="index+'1'">
          <div class="cartop">
            <div class="img">
              <img src="./../../assets/takingCar/eco.png" alt v-show="item.carType == '经济'" />
              <img src="./../../assets/takingCar/comfort.png" alt v-show="item.carType == '舒适'" />
              <img src="./../../assets/takingCar/business.png" alt v-show="item.carType == '商务'" />
            </div>
            <div class="cartip">
              <p class="title">{{item.carType}}</p>
              <p>{{item.tip}}</p>
            </div>
          </div>
          <div class="carbottom">
            <div
              class="in"
              v-for="(car,i) in item.carList"
              :key="i"
              @click="selectcar(item,index,car,i)"
              data-checked="unchecked"
              :class="{'select':car.selected}"
            >
              <img src="./../../assets/takingCar/wait.png" alt class="caricon" />
              <h2>{{car.carName}}</h2>
              <p class="tip">{{car.timeTip}}</p>
              <p class="tip">{{car.waitTip}}</p>
              <p class="money">
                <span>{{car.money}}</span>元（一口价）
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot" :class="{'active':isbutton}">
      <div>
        <p class="left">
          预支付：
          <span>{{allMoney}}</span> 元
        </p>
        <button class="right" @click="call()">立即呼叫</button>
      </div>
    </div>
    <van-popup v-model="show" position="top" :class="{'isiOSX':isiOSX}">
      <div class="popup">
        <p class="popuptitle" @click="packUp()">
          航班MU2648 05月12日 20:25达到后接机
          <img src="./../../assets/takingCar/packup.png" alt />
        </p>
        <h2>行程信息</h2>
        <div class="popupContent">
          <p>杭州萧山国际机场T2航站楼</p>
          <p>泛海国际中心东门</p>
          <p>5月12日 11:15</p>
        </div>
        <h2>航班信息</h2>
        <div class="popopTip">
          <div>
            <h2>18:00</h2>
            <p>首都机场 T2</p>
          </div>
          <div>MU2648</div>
          <div>
            <h2>18:00</h2>
            <p>首都机场 T2</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      active: 0,
      carTypeList: [
        {
          carType: "经济",
          litleTip: "93.5元起",
          tip: "最多容纳4人(含儿童)；2件20寸行李",
          carList: [
            {
              carName: "曹操出行",
              timeTip: "05月12日 11:05 前可免费取消",
              waitTip: "免费等待10分钟",
              money: "25.6",
              id: 1
            },
            {
              carName: "一道出行",
              timeTip: "05月12日 11:05 前可免费取消",
              waitTip: "免费等待10分钟",
              money: "25.6",
              id: 2
            }
          ]
        },
        {
          carType: "舒适",
          litleTip: "93.0元起",
          tip: "最多容纳4人(含儿童)；2件20寸行李",
          carList: [
            {
              carName: "曹操出行",
              timeTip: "05月12日 11:05 前可免费取消",
              waitTip: "免费等待10分钟",
              money: "25.62",
              id: 3
            }
          ]
        },
        {
          carType: "商务",
          litleTip: "93.0元起",
          tip: "最多容纳4人(含儿童)；2件20寸行李",
          carList: [
            {
              carName: "曹操出行",
              timeTip: "05月12日 11:05 前可免费取消",
              waitTip: "免费等待10分钟",
              money: "25.60",
              id: 4
            },
            {
              carName: "曹操出行",
              timeTip: "05月12日 11:05 前可免费取消",
              waitTip: "免费等待10分钟",
              money: "25.61",
              id: 5
            }
          ]
        }
      ],
      ischeck: false,
      isbutton: false,
      selectList: [],
      show: false,
      selectNum1: 0,
      selectNum2: 0,
      selectNum3: 0,
      allMoney: "0.00"
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.daraFormatting();
    this.carTypeList[0].checked = true;
  },
  watch: {
    $route: "getPath"
  },
  methods: {
    // 格式化数据，添加selected属性，控制是否选中样式
    daraFormatting() {
      this.carTypeList.forEach(item => {
        item.checked = false; //tab状态
        item.iconCheck = false; //徽章状态
        item.num = 0;
        item.carList.forEach(i => {
          i.selected = false;
        });
      });
    },
    //   车型筛选
    carTab(item, index) {
      if (!item.checked) {
        this.carTypeList.forEach(i => {
          i.checked = false;
        });
        item.checked = true;
      }
      this.carTypeList = [...this.carTypeList];
      //   金额总计重置
      this.allMoney = "0.00";
    },
    // 车辆选择
    selectcar(cartypelist, index, item, i) {
      item.selected = !item.selected;
      if (item.selected) {
        //选中
        this.isbutton = true;
        this.selectList.push(item.id);
        // 预支付金额变化
        this.allMoney = (
          parseFloat(this.allMoney) + parseFloat(item.money)
        ).toFixed(2);
        // 徽章
        cartypelist.iconCheck = true;
        cartypelist.num++;
      } else {
        //取消
        // 预支付金额变化
        this.allMoney = (
          parseFloat(this.allMoney) - parseFloat(item.money)
        ).toFixed(2);
        // 取消选中，从已选数组删除
        let num = this.selectList.indexOf(item.id);
        if (num > -1) {
          this.selectList.splice(num, 1);
        }
        // 如果已选数组为空，则改变按钮状态为不可点击状态
        if (this.selectList.length == 0) {
          this.isbutton = false;
        }
        //徽章
        cartypelist.num--;
        if (cartypelist.num <= 0) {
          cartypelist.iconCheck = false;
        }
      }
      this.carTypeList = [...this.carTypeList];
    },
    // 展开行程信息
    journeyInformation() {
      this.show = true;
    },
    // 收起行程信息
    packUp() {
      this.show = false;
    },
    // 返回
    goBack(){
      console.log('返回返回')
    },
    call() {
      if (this.selectList.length > 0) {
        console.log("呼叫");
        for (let i = 0; i < this.selectList.length; i++) {
          console.log(this.selectList[i]);
        }
      }
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.selectCar {
  min-height: 100%;
  background: #f5f5f5;
  .top {
    color: #333333;
    font-size: 14px;
    line-height: 20px;
    padding-top: 34px;
    background: #ffffff;
    padding-bottom: 15px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    img {
      width: 17px;
      height: 17px;
      margin: 0 3px 0 20px;
      position: relative;
      top: 3px;
    }
    span {
      padding-right: 16px;
      background: url(./../../assets/takingCar/unfold.png) no-repeat center
        right;
      background-size: 8.5px;
    }
  }

  .content {
    margin-top: 90px;
    padding-bottom: 99px;
    .left {
      text-align: center;
      width: 80px;
      background: #f5f5f5;
      color: #666666;
      font-size: 16px;
      line-height: 22px;
      position: fixed;
      left: 0;
      top: 71px;
      div {
        background: #f5f5f5;
        color: #666666;
        padding: 15px 0 15px;
        position: relative;
        p {
          margin-bottom: 7px;
        }
        .tiptitle {
          font-size: 11px;
          line-height: 16px;
          display: inline-block;
        }
        .rightIcon {
          position: absolute;
          top: 5px;
          right: 5px;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          background: #ffb600;
          color: #333333;
          font-size: 11px;
          line-height: 13px;
        }
      }
      .checktab {
        background: #ffffff;
        color: #333333;
      }
    }
    .right {
      background: #ffffff;
      padding: 0 15px 0 10px;
      margin-left: 80px;
      .carlist {
        margin-top: 25px;
        .cartop {
          display: flex;
          .img {
            width: 40px;
            height: 40px;
            margin: 0 10px;
            img {
              width: 100%;
            }
          }
          .cartip {
            flex: 1;
            color: #999999;
            font-size: 12px;
            line-height: 17px;
            .title {
              color: #333333;
              font-size: 16px;
              line-height: 22px;
              margin-bottom: 5px;
            }
          }
        }
        .carbottom {
          margin-top: 5px;
          .in {
            border: 3px solid #dddddd;
            border-radius: 5px;
            color: #333333;
            position: relative;
            margin-top: 10px;
            .caricon {
              position: absolute;
              top: 12px;
              left: 15px;
              width: 16px;
              height: 18px;
            }
            h2 {
              padding-left: 43px;
              font-size: 16px;
              line-height: 22px;
              margin: 10px 0 7px;
            }
            .tip {
              color: #999999;
              font-size: 12px;
              line-height: 17px;
              padding-left: 43px;
            }
            .money {
              padding-left: 43px;
              margin: 10px 10px 10px 0;
              background: none;
              span {
                font-size: 20px;
                line-height: 28px;
              }
            }
            .checked {
              width: 16px;
              height: 16px;
              position: absolute;
              right: 10px;
              bottom: 14px;
            }
          }
          .select {
            border: 3px solid #ffb600;
            .money {
              background: url(./../../assets/takingCar/checked.png) no-repeat
                right center;
              background-size: 16px;
            }
          }
        }
      }
    }
  }
  .foot {
    height: 81px;
    background: #ffffff;
    box-shadow: 1px 1px 6px #181818;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding-top: 10px;
    color: #999999;
    div {
      margin: 0 15px;
      display: flex;
      justify-content: space-between;
      button {
        height: 45px;
        border-radius: 5px;
        font-size: 15px;
        line-height: 21px;
      }
      .left {
        flex: 1;
        height: 30px;
        line-height: 30px;
        margin-top: 8px;
        margin-left: 5px;
        span {
          font-size: 22px;
          font-weight: bolder;
        }
      }
      .right {
        flex: 1.1;
        background: #e0e0e0;
        border: none;
      }
    }
  }
  .active {
    div {
      .left {
        color: #333333;
      }
      .right {
        background: #181818;
        color: #ffffff;
      }
    }
  }
  .van-popup {
    padding: 34px 0 20px;
    .popup {
      color: #333333;
      font-size: 13px;
      line-height: 18px;
      margin: 0 26px;
      .popuptitle {
        color: #000000;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 5px;
        font-weight: bold;
        img {
          width: 10px;
          margin-left: 7px;
        }
      }
      h2 {
        font-size: 16px;
        line-height: 22px;
        margin: 15px 0 15px 3px;
        font-weight: bolder;
      }
      .popupContent {
        margin-left: 3px;
        p {
          padding-left: 22px;
        }
        p:nth-child(1) {
          background: url(./../../assets/takingCar/qsd.png) no-repeat center
            left;
          background-size: 11px;
        }
        p:nth-child(2) {
          margin: 15px 0;
          background: url(./../../assets/takingCar/zd.png) no-repeat center left;
          background-size: 11px;
        }
        p:nth-child(3) {
          background: url(./../../assets/takingCar/time.png) no-repeat center
            left;
          background-size: 11px;
        }
      }
      .popopTip {
        margin: 0 3px;
        border: 1px solid #e1e1e1;
        border-radius: 5px;
        height: 77px;
        display: flex;
        justify-content: space-around;
        padding: 0 20px;
        h2 {
          font-size: 22px;
          line-height: 30px;
          margin: 15px 0 0;
        }
        p {
          font-size: 12px;
          line-height: 17px;
        }
        div:nth-child(2) {
          text-align: center;
          line-height: 77px;
          width: 82px;
          color: #e1e1e1;
          font-size: 12px;
          background: url(./../../assets/takingCar/flight.png) no-repeat center
            center;
          background-size: 81px;
        }
      }
    }
  }
  .isiOSX {
    padding-top: 54px;
  }
  .isIosLeft {
    top: 91px !important;
  }
  .isIosContent {
    margin-top: 110px;
  }
}
</style>
